import React from 'react'
import as0 from '../images/as0.jpeg'
import as900 from '../images/as900.jpeg'
import asv from '../images/asv.jpeg'

const Header = () => {
  return (
    <header>
        <div id="carouselExample" class="carousel slide">
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src={as0} class="d-block w-100" alt="..."/>
    </div>
    <div class="carousel-item">
      <img src={as900} class="d-block w-100" alt="..."/>
    </div>
     <div class="carousel-item">
      <img src={asv} class="d-block w-100" alt="..."/>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
    </header>
  )
}

export default Header
